import { ChevronRight, SearchOff } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import useFormatMessage from '@/hooks/useFormatMessage';

export default function DropdownEmptyState({
  query,
  variant,
  onRequestFreeText,
  onOpenContact,
}) {
  const formatMessage = useFormatMessage();
  const trimmed = query?.trim();
  const isError = variant === 'error';

  return (
    <Box sx={{ px: 5, py: 4.5, textAlign: 'center' }}>
      <SearchOff sx={{ fontSize: 40, color: 'grayscale.400' }} />
      <Typography
        variant="h6Redesign"
        component="p"
        sx={{ mt: 1.25, color: 'text.primary' }}>
        {formatMessage(
          isError
            ? 'rental_request_flow_error_headline'
            : 'rental_request_flow_empty_headline'
        )}
      </Typography>
      <Typography
        variant="body2"
        sx={{ mt: 1, mx: 'auto', maxWidth: 480, color: 'text.secondary' }}>
        {formatMessage(
          isError
            ? 'rental_request_flow_error_body'
            : 'rental_request_flow_empty_body'
        )}
      </Typography>

      {trimmed && (
        <Button
          data-test-subject="request-asset-button"
          variant="contained"
          size="extraLarge"
          endIcon={<ChevronRight />}
          onClick={() => onRequestFreeText(trimmed)}
          sx={{ mt: 2.5 }}>
          {formatMessage('rental_request_flow_empty_cta', { query: trimmed })}
        </Button>
      )}

      <Box sx={{ mt: 1.75 }}>
        <Button
          variant="text"
          size="medium"
          onClick={onOpenContact}
          sx={{ minHeight: 44 }}>
          {formatMessage('rental_request_flow_empty_contact')}
        </Button>
      </Box>
    </Box>
  );
}

DropdownEmptyState.propTypes = {
  query: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['zero_results', 'error']).isRequired,
  onRequestFreeText: PropTypes.func.isRequired,
  onOpenContact: PropTypes.func.isRequired,
};
